// Yanmar 4JH3-TE fuel curve — single source of truth for the whole app.
// Fuel burn (gal/hr) along the propeller-demand curve, derived from the datasheet:
// rated 55 kW (75 hp) @ 3800 rpm, prop power ∝ rpm³, BSFC ~220–260 g/kWh, density 0.842 g/cm³.
// Boat speed (kts) is empirical for the SO45 in flat water, no current (used for range only).
export const FUEL_RANGE_CURVE = [
  { rpm:1800, gph:0.48, kts:4.2 },
  { rpm:2000, gph:0.63, kts:5.0 },
  { rpm:2200, gph:0.82, kts:5.8 },
  { rpm:2400, gph:1.04, kts:6.3 },
  { rpm:2600, gph:1.30, kts:6.8 },
  { rpm:2800, gph:1.59, kts:7.2 },
  { rpm:3000, gph:1.94, kts:7.5 },
  { rpm:3200, gph:2.32, kts:7.7 },
  { rpm:3400, gph:2.76, kts:7.8 },
  { rpm:3600, gph:3.24, kts:7.9 },
  { rpm:3800, gph:3.80, kts:8.0 },
];

// rpm -> gal/hr lookup, derived from the curve above (used by the entry-form estimate).
export const YANMAR_CURVE = Object.fromEntries(FUEL_RANGE_CURVE.map(r => [r.rpm, r.gph]));

export const TRIP_TYPES  = ['Day Sail','Passage','Race','Delivery','Training','At Anchor','At Dock'];

// Stays are time aboard without a passage: one location, no distance.
export const STAY_TYPES  = ['At Anchor','At Dock'];
// 'Day at Anchor' is the legacy value for stays; keep it recognised.
export const isStay = (t) => STAY_TYPES.includes(t) || t === 'Day at Anchor';
export const DEST_TYPES  = ['Marina','Anchor','Mooring','SYC','Other YC','Haul-out'];
export const BARO_TREND  = ['Rising','Steady','Falling','Falling rapidly'];
export const VISIBILITY_OPTS = ['Excellent (>10nm)','Good (5-10nm)','Moderate (2-5nm)','Poor (<2nm)','Fog'];

export const DEFAULT_SETTINGS = {
  engine_baseline:  2940,
  gen_baseline:     1130,
  hull_nm_baseline: 12934,
  tank1_cap:        90,
  tank2_cap:        38,
  water_aft_cap:    240,
  phrf:             144,
  home_marina:      'Elliott Bay Marina',
  slip:             'D-4',
  home_lat:         47.6234,
  home_lon:        -122.3927,
};
